import { createReactiveContext } from '../../../../helpers/reactiveContext';

const {
  Provider: StateProvider,
  useSelector: useStateSelector,
  useMethods: useStateMethods,
} = createReactiveContext();

export { StateProvider, useStateSelector, useStateMethods };
